import { debounce, put, select, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import { FILTER_APPLY_DEBOUNCE_TIME } from '../config';
import { DASHBOARD_FILTER_TYPES } from '../filter-types';
import { selectDashboardNotEmptyFilterState } from '../selectors';
import * as appointmentList from '../requests/appointment-list-req';

function* fetchFilteredAppointments() {
  const { date: originDate, ...rest } = yield select(
    selectDashboardNotEmptyFilterState,
  );

  const date = moment(originDate)
    .startOf('day')
    .toISOString(true);

  const options = { ...rest, date: encodeURIComponent(date) };
  yield put(appointmentList.actions.send(options));
}

export default function* reloadOnFilterChange() {
  yield debounce(
    FILTER_APPLY_DEBOUNCE_TIME,
    DASHBOARD_FILTER_TYPES.SET_FILTER,
    fetchFilteredAppointments,
  );

  yield takeLatest(
    DASHBOARD_FILTER_TYPES.ADD_DISPLAYABLE_BY_DEFAULT,
    fetchFilteredAppointments,
  );
}



// WEBPACK FOOTER //
// ./src/redux/dashboard/sagas/reload-on-filter-change.js